import { apiClient, ApiResponse } from './client'

export interface SelfRegisterChild {
  studentName: string
  handle: string
  dateOfBirth: string | null
  gradeLabel: string | null
}
export interface SmsVerifyResult { sessionToken: string; children: SelfRegisterChild[] }
export interface CheckHandleResult { available: boolean }
export interface SelfRegisterSubmitResult { handle: string; alreadyRegistered: boolean }

export interface SelfRegisterStudentInput {
  handle: string; fullName: string; dateOfBirth: string; gender?: string; school?: string
}
export interface SelfRegisterGuardianInput {
  name: string; phone: string; postalCode?: string; addressBase?: string; addressDetail?: string
}
export interface SelfRegisterConsentInput {
  termsAgreed: boolean; marketingAgreed: boolean; termsVersion: string
}

const base = '/lc/auth/self-register'

export async function requestSelfRegisterSms(guardianName: string, guardianPhone: string): Promise<void> {
  await apiClient.post<ApiResponse<void>>(`${base}/sms/request`, { guardianName, guardianPhone })
}

export async function verifySelfRegisterSms(guardianPhone: string, code: string): Promise<SmsVerifyResult> {
  const res = await apiClient.post<ApiResponse<SmsVerifyResult>>(`${base}/sms/verify`, { guardianPhone, code })
  return res.data.data!
}

export async function checkSelfRegisterHandle(sessionToken: string, handle: string): Promise<CheckHandleResult> {
  const res = await apiClient.post<ApiResponse<CheckHandleResult>>(`${base}/check-handle`, { sessionToken, handle })
  return res.data.data!
}

export async function submitSelfRegister(
  sessionToken: string,
  student: SelfRegisterStudentInput,
  guardian: SelfRegisterGuardianInput,
  consent: SelfRegisterConsentInput,
): Promise<SelfRegisterSubmitResult> {
  const res = await apiClient.post<ApiResponse<SelfRegisterSubmitResult>>(
    `${base}/submit`, { sessionToken, student, guardian, consent },
  )
  return res.data.data!
}

export const TERMS_VERSION = '2026-08-10'
